import React, { Component } from 'react';
import Main from './components/main/component';

const App = () => (
      <div>
          <Main/>
      </div>
);

export default App



// WEBPACK FOOTER //
// ./src/App.js